import updateCustomerAddress from './updateCustomerAddress';

export default updateCustomerAddress;
